// extracted by mini-css-extract-plugin
module.exports = {"status":"index-module_status_1pzds","off":"index-module_off_2kCOd"};